import gql from 'graphql-tag';

const UPDATE_PROJECT = gql`
  mutation updateProject($data: ProjectUpdateInput!, $where: ProjectWhereUniqueInput!) {
    updateProject(data: $data, where: $where) {
      id
      name
      description
      status
      priority
      startDate
      endDate
      createdAt
      updatedAt
      owner {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      team {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      tasks: assignedTasks {
        id
        name
        status
        dueDate
        urgency
        assigneeUsers {
          id
          name
          username
        }
      }
    }
  }
`;

export default UPDATE_PROJECT;
